$(document).ready(function() {
    // Calcular total de cada card ao marcar/desmarcar checkbox
    $(document).on('change', '.coverage-checkbox', function() {
        updateCardTotal($(this));
    });

    function updateCardTotal(checkbox) {
        var card = checkbox.closest('.card');
        var total = 0;

        card.find('.coverage-checkbox:checked').each(function() {
            var amount = parseFloat($(this).data('amount')) || 0;
            total += amount;
        });

        card.find('.total-amount').text(formatCurrency(total));
    }

    function formatCurrency(value) {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    // Calcular totais iniciais ao carregar a página
    $('.coverage-checkbox:checked').each(function() {
        updateCardTotal($(this));
    });
});